import styled, { createGlobalStyle } from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import CloseIconImage from 'assets/img/campanhas-de-marketing/close-icon.svg';

export const BackdropStyles = createGlobalStyle`
  .campaign-help-backdrop.show {
    background: #414141;
    opacity: 0.65;
  }
`;

export const ModalStyled = styled(Modal)`
  .campaign-help-modal {
    width: 600px;
    max-width: calc(100vw - 32px);
    margin-right: auto;
    margin-left: auto;

    @media (min-width: 576px) {
      max-width: calc(100vw - 32px);
    }
  }

  .modal-content {
    display: flex;
    max-height: min(660px, calc(100vh - 32px));
    overflow: hidden;
    border: 1px solid #d7dce3;
    border-radius: 24px;
    background: #fff;
    box-shadow: 0 8px 24px rgba(51, 55, 60, 0.16);
    color: #33373c;
    font-family: 'Roboto Flex', sans-serif;
  }
`;

export const Header = styled.header`
  position: relative;
  display: flex;
  min-height: 28px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 23px 68px 0;
`;

export const Title = styled.h2`
  margin: 0;
  color: #33373c;
  font-family: 'Roboto Flex', sans-serif;
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0;
  text-align: center;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 11px;
  right: 14px;
  display: inline-grid;
  width: 52px;
  height: 52px;
  place-items: center;
  border: 0;
  border-radius: 50%;
  padding: 0;
  background: transparent;
  color: #33373c;

  &:hover,
  &:focus-visible {
    background: #e7eaef;
  }

  &:active {
    background: #c8e6ff;
    color: #0c50d3;
  }
`;

export const CloseIcon = styled.span`
  width: 24px;
  height: 24px;
  background: currentColor;
  -webkit-mask: url(${CloseIconImage}) center / contain no-repeat;
  mask: url(${CloseIconImage}) center / contain no-repeat;
`;

export const Body = styled.div`
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 16px 40px 0;

  @media (max-width: 575px) {
    padding-right: 24px;
    padding-left: 24px;
  }
`;

export const Sections = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $compact }) => ($compact ? '22px' : '24px')};
`;

export const Section = styled.section`
  h3 {
    margin: 0 0 8px;
    color: #33373c;
    font-family: 'Roboto Flex', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0;
  }

  p {
    margin: 0;
    color: #33373c;
    font-family: 'Roboto Flex', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  padding: 16px 16px 15px;
`;

export const ConfirmButton = styled.button`
  min-width: 96px;
  height: 40px;
  border: 0;
  border-radius: 999px;
  padding: 10px 24px;
  background: #0c50d3;
  color: #fbfbfb;
  font-family: 'Roboto Flex', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  &:hover,
  &:focus-visible {
    background: #1670fa;
    box-shadow: 0 8px 24px rgba(21, 87, 217, 0.2);
  }

  &:active {
    background: #164194;
    box-shadow: none;
  }
`;

export const Instructions = styled.div`
  color: #33373c;
  font-family: 'Roboto Flex', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;

  p {
    margin: 0;
    color: #33373c;
    font-family: 'Roboto Flex', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
  }

  a {
    color: #0c50d3 !important;
    text-decoration: none;

    &:hover,
    &:focus-visible {
      text-decoration: underline;
    }
  }
`;

export const InstructionIntro = styled.p`
  margin-bottom: 20px !important;
`;

export const InstructionList = styled.ul`
  margin: 0 0 20px;
  padding-left: 22px;
  list-style: disc outside;

  li {
    display: list-item;
    list-style: disc outside;
  }
`;

export const ExampleLabel = styled.p`
  margin-bottom: 8px !important;
`;

export const SpreadsheetImage = styled.img`
  display: block;
  width: 100%;
  max-width: 520px;
  height: auto;
  aspect-ratio: 520 / 172;
`;
